import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

class ScrollText {
    private element: HTMLElement;
    private animation?: gsap.core.Tween;

    constructor(element: HTMLElement) {
        this.element = element;
        const isLargeScreen = window.innerWidth >= 800; // 50rem = 800px

        if (isLargeScreen) {
            this.init();
        }
    }

    private init() {
        // Start off-screen right
        gsap.set(this.element, { xPercent: 100 });

        this.animation = gsap.to(this.element, {
            xPercent: -50, // Move completely off-screen left
            ease: "none",   // Keep linear for smooth scroll control
            scrollTrigger: {
                trigger: this.element,
                start: "center bottom", // starts when element center hits bottom of viewport
                end: "center top",      // ends when element center leaves top of viewport
                scrub: 1.25,            // ties movement to scroll position
                markers: false,         // set true to debug
            },
        });
    }

    public kill() {
        this.animation?.kill();
        ScrollTrigger.getById(this.element.id)?.kill();
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const textElements = document.querySelectorAll(".scroll-text") as NodeListOf<HTMLElement>;
    textElements.forEach((textEl) => {
        new ScrollText(textEl);
    });
});
